import { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'motion/react';

// NOTE: you only pasted the *usage* snippet for react-bits' RotatingText
// (`npx shadcn@latest add @react-bits/RotatingText-JS-CSS`), not its source,
// so this is a small from-scratch component matching that same API
// (texts / rotationInterval / staggerDuration / splitBy / loop / auto) —
// swap in the real one later if you pull its actual source.
export default function RotatingText({
  texts = [],
  rotationInterval = 2000,
  staggerDuration = 0.025,
  splitBy = 'characters',
  loop = true,
  auto = true,
  style,
}) {
  const [index, setIndex] = useState(0);

  useEffect(() => {
    if (!auto || texts.length < 2) return;
    const id = setInterval(() => {
      setIndex((i) => {
        const next = i + 1;
        if (next >= texts.length) return loop ? 0 : i;
        return next;
      });
    }, rotationInterval);
    return () => clearInterval(id);
  }, [auto, loop, rotationInterval, texts.length]);

  const current = texts[index] || '';
  const pieces = splitBy === 'characters' ? Array.from(current) : current.split(' ');

  return (
    <span
      style={{
        position: 'relative',
        display: 'inline-flex',
        overflow: 'hidden',
        verticalAlign: 'bottom',
        ...style,
      }}
    >
      <AnimatePresence mode="wait">
        <motion.span key={current} style={{ display: 'inline-flex' }}>
          {pieces.map((piece, i) => (
            <motion.span
              key={i}
              style={{ display: 'inline-block' }}
              initial={{ y: '100%', opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: '-120%', opacity: 0 }}
              transition={{ type: 'spring', damping: 30, stiffness: 400, delay: i * staggerDuration }}
            >
              {piece === ' ' ? '\u00A0' : piece}
            </motion.span>
          ))}
        </motion.span>
      </AnimatePresence>
    </span>
  );
}
